import { useActivePromo } from '@/services/campaignService'
import PromoBanner from './PromoBanner'
import PromoFloating from './PromoFloating'
import PromoPopup from './PromoPopup'

// ใส่ใน layout หลัก: <PromoBannerSlot /> ต่อจาก <Navbar /> · <PromoFloatingSlot /> และ <PromoPopupSlot /> ที่ไหนก็ได้ (fixed)
// ข้อมูลมาจาก GET /api/campaigns/active (ตัวเก็บกลางใน campaignService — ยิงครั้งเดียว ใช้ร่วมกันทั้งสามส่วน)
// ไม่มีข้อมูล/โหลดไม่ได้/ไม่มีแคมเปญที่เปิดอยู่ = ไม่เรนเดอร์อะไรเลย

export function PromoBannerSlot() {
  const promo = useActivePromo()
  const c = promo?.campaign
  return c && c.banner ? <PromoBanner campaign={c} clockOffsetMs={promo.clockOffsetMs} /> : null
}

export function PromoFloatingSlot() {
  const c = useActivePromo()?.campaign
  return c && c.floating ? <PromoFloating campaign={c} /> : null
}

export function PromoPopupSlot() {
  const promo = useActivePromo()
  return promo && promo.popups.length > 0 ? <PromoPopup popups={promo.popups} /> : null
}
